import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 2, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-2xl bg-black/40 border-b border-white/10" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-bebas text-3xl tracking-[0.15em] text-white leading-none flex items-center gap-2"
        >
          Asraf Noor<span className="text-[#e1ff00]">.</span>
        </a>

        <a
          href="#contact"
          data-testid="nav-cta"
          className="font-outfit text-xs uppercase tracking-[0.2em] font-bold text-black bg-[#e1ff00] px-5 py-2.5 rounded-full hover:bg-white transition-colors duration-300"
        >
          Contact
        </a>
      </div>
    </motion.nav>
  );
};
